<template>
  <AccordionItem
    v-if="
      filterName === 'downloadCategory.values.label.data' ||
      (store.filters['downloadCategory.values.label.data'] &&
        store.filters['downloadCategory.values.label.data'].length)
    "
    :is-open="true"
  >
    <template #title>{{ label }}</template>
    <ExpandableInputList
      :key="filterName"
      :type="'checkbox'"
      :label="label"
      :name="filterName"
      :value="store.filters[filterName]"
      :disabled="isDisabled"
      :options="options"
      :show-more-label="
        $textDictionary['productsList.filters.button.showmore.label']
      "
      :show-less-label="
        $textDictionary['productsList.filters.button.showless.label']
      "
      :displayed-options="5"
      @change="
        (name: string, value: string | string[]) =>
          store.handleFormValueChange(name, value)
      "
    />
  </AccordionItem>
</template>

<script setup lang="ts">
import { useDownloadStore } from '~/stores/downloadStore/softwareDownloadStore';
import { AccordionItem } from '@hypercodestudio/basler-components';
import ExpandableInputList from './../../shop/ExpandableInputList.vue';
import { useSoftwareOsLabel } from '~~/lib/DownloadService/helper/useSoftwareOsLabel';
import type { FacetValueModel } from '~~/lib/DownloadService/model';

interface Props {
  filterItems: FacetValueModel[];
  filterName: string;
}

const props = defineProps<Props>();

const { $textDictionary } = useNuxtApp();
const store = useDownloadStore();

const softwareTypeLabelPrefix = 'softwareCenter.softwareFilter.';

const isDisabled = computed(
  () => store.filterDisabledList[props.filterName] ?? false
);
const label = computed(
  () =>
    $textDictionary.value[
      softwareTypeLabelPrefix + props.filterName + '.label'
    ] ?? props.filterName
);

const options = computed<Record<string, string>>(() => {
  const optionsWithLabels: Record<string, string> = {};

  // we always show active filters as a facet search might hide those
  // (or they are not included in the default filters).
  /* activeValues.value?.forEach((value) => {
    if (!optionsWithLabels[value]) {
      optionsWithLabels[value] = value;
    }
  });*/

  props.filterItems.forEach(({ value, count }) => {
    if (props.filterName === 'groupAssets.supportedOs.data') {
      optionsWithLabels[value] = `${useSoftwareOsLabel(value)} (${count})`;
    } else {
      optionsWithLabels[value] = `${value} (${count})`;
    }
  });

  return optionsWithLabels;
});
</script>
